import React, { useState } from 'react';

/**
 * Square avatar that shows the crop rect {x, y, width, height} (in source-image
 * pixels) of the full stored image — the backend now keeps the whole upload and
 * only records where to crop, so the crop is applied here at display time.
 *
 * The parent element must be a square with `position: relative; overflow: hidden`
 * (the avatar buttons already are). With no crop we just fall back to the plain
 * `object-fit: cover` styling the className provides.
 */
export default function AvatarImage({ src, crop, className, alt = '' }) {
  const [nat, setNat] = useState(null); // { w, h } natural size, read on load

  const cropped = crop && crop.width > 0 && nat;
  // Percent-of-container per source pixel: the crop width fills the square box.
  const s = cropped ? 100 / crop.width : 0;
  const style = cropped
    ? {
        position: 'absolute',
        width: `${nat.w * s}%`,
        height: `${nat.h * s}%`,
        left: `${-crop.x * s}%`,
        top: `${-crop.y * s}%`,
        maxWidth: 'none',
      }
    : undefined;

  return (
    <img
      className={className}
      src={src}
      alt={alt}
      style={style}
      onLoad={(e) => setNat({ w: e.target.naturalWidth, h: e.target.naturalHeight })}
    />
  );
}
